import axios, { AxiosError } from 'axios';
import { useMutation } from '@tanstack/react-query';
import { OfficeProfileUpdateRo } from '@/types';
import { POST_OFFICE_PROFILE } from '@/constants';

export const useUpdateOfficeProfile = () =>
  useMutation<void, AxiosError, OfficeProfileUpdateRo>({
    mutationFn: (data) => axios.post(POST_OFFICE_PROFILE, data).then((res) => res.data),
  });
